// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { headerStyles } from "@insite/content-library/Widgets/AccountSettings/AccountSettingsHeader";
import { xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

headerStyles.buttonSet = {
    css: css`
        gap: 10px;
        &&&& {
            margin-top: 20px;
        }
        ${xScreen("lt", "xs")} {
            flex-direction: column-reverse;
        }
    `,
    width: 12,
};

headerStyles.cancelButton = {
    variant: "secondary",
    css: css`
        ${xScreen("lt", "xs")} {
            width: 100%;
        }
    `,
};
headerStyles.saveButton = {
    css: css`
        ${xScreen("lt", "xs")} {
            width: 100%;
        }
    `,
};

